/**
 * @namespace ChartbeatTracking
 * @aka SWRNEU.ChartbeatTracking
 *
 * @type {{}}
 */
SWRNEU.ChartbeatTracking = function ($) {

  var NAME = 'chartbeatPageview';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PAGEVIEW: 'pageview' + EVENT_KEY
  };

  /**
   * @param {object} options
   */
  var pageview = function pageview(options) {
    if ('undefined' === typeof window.pSUPERFLY) {
      return;
    }

    /*
     * Opt-Out Cookie
     */
    var cookie = Cookies.get('tracking_optout', {path: '/'});
    
    if ('undefined' !== typeof cookie && cookie.indexOf('chartbeat') !== -1) {
      //Wenn das Cookie existiert und Chartbeat drin steht, muss abgebrochen werden
      return;
    }

    var $chartbeat = $('#chartbeat');
    if (0 === $chartbeat.length) {
      return;
    }

    if (typeof options === 'undefined') {
      options = {};
    }

    var canonicalUrl = '';
    var links = document.querySelectorAll('link[rel="canonical"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].hasAttribute('href')) {
        canonicalUrl = links[i].getAttribute('href');
      }
    }

    options = extend(true, {}, {
      title: document.title,
      url: canonicalUrl,
      ati: {}
    }, options)

    // Wenn der canonical extern ist dann diesen nicht verwenden
    if (COMMON.Utils.parseUrl(document.URL).host !== COMMON.Utils.parseUrl(canonicalUrl).host) {
      options.url = document.URL;
    }

    if (window.location.origin + '/administration/404-error-swr-100.html' === canonicalUrl || window.location.origin + '/administration/404-error-herzenssache-100.html' === canonicalUrl) {
      options.url = document.URL;
    }

    options.path = COMMON.Utils.parseUrl(options.url).relative;

    try {
      window.pSUPERFLY.virtualPage({
        path: options.path,
        title: options.title,
        sections: ($chartbeat.attr('data-sections') || ''),
        authors: ($chartbeat.attr('data-authors') || '')
      });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e)
    }
  }

  $(document)
    .on('pjax:end', function (event, xhr, options) {
      pageview();
    })
    .on(Event.PAGEVIEW + ' common:pixel:pageview.chartbeat shown.bs.collapse swr:collapse:shown', function (event, options) {
      pageview(options)
    });

  return {
    pageview: pageview
  };

}(window.jQuery);
